import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import get from 'lodash/get';
import {
  fragments as filterFragments,
  inventoryItemIsSafe
} from '../../../lib/filters';

export const searchResultsQuery = customFragments => {
  const allFragments = [...filterFragments, ...customFragments];
  const inventoryItemFragments = allFragments.filter(
    ({ type }) => type === 'ihs_InventoryItemsItem'
  );

  return gql`
    query searchResults(
      $searchQueryParams: SearchQueryParams!,
      $locale: String!,
      $currency: String!,
      $country: String!,
      $previewTypeIds: [String!]!,
      $unit: ihs_Unit!,
    ) {
      searchResults(searchQueryParams: $searchQueryParams, locale: $locale, currency: $currency, country: $country, previewTypeIds: $previewTypeIds, unit: $unit) {
        ${
          inventoryItemFragments.length > 0
            ? `
        inventoryItems(locale: $locale, currency: $currency, country: $country, previewTypeIds: $previewTypeIds, unit: $unit) {
          ${inventoryItemFragments.map(({ name }) => `...${name}`).join('\n')}
        }
        `
            : ''
        }
      }
    }

    ${inventoryItemFragments.reduce(
      (acc, { fragment }) => gql`
        ${acc}
        ${fragment}
      `,
      ''
    )}
  `;
};

export const useSearchResults = ({
  fragments,
  searchQueryParams,
  locale,
  country,
  currency
}) => {
  const unit = currency === 'USD' ? 'IN' : 'CM';
  const previewTypeIds = ['product_close'];
  const query = searchResultsQuery(fragments);
  const variables = {
    searchQueryParams,
    locale,
    country,
    currency,
    previewTypeIds,
    unit
  };
  const skip = !(searchQueryParams && locale && country && currency);
  const ssr = false;

  const { data, loading, error } = useQuery(query, { variables, skip, ssr });
  const items = get(data, 'searchResults.inventoryItems', []).filter(
    inventoryItemIsSafe
  );
  return { items, loading, error };
};

export default useSearchResults;
